import { _ as _define_property } from "@swc/helpers/_/_define_property";
import React from 'react';
import { compose } from 'redux';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import { withTranslation } from 'react-i18next';
import IconButton from '../../../Button/IconButton';
import UploadIcon from '@wix/da-ds/pkg/Icons/24x24/Upload';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { withMobileContext } from '@wix/da-react-context/pkg/MobileContext';
import withFileUpload from '../../_hocs/withFileUpload';
import { withVerification } from '../../../VerificationPopup/withVerification';
import { MIME_CONFIG } from '../../../utils/mime';
const enhance = compose(withVerification, withFileUpload, withMobileContext, withTranslation());
class UploadButton extends React.Component {
    render() {
        const { className, isMobile, t } = this.props;
        return /*#__PURE__*/ React.createElement(React.Fragment, null, isMobile && /*#__PURE__*/ React.createElement(IconButton, {
            className: 'astro',
            onClick: this.chooseFile
        }, /*#__PURE__*/ React.createElement(UploadIcon, {
            withPadding: true,
            size: IconSize.MEDIUM
        })), !isMobile && /*#__PURE__*/ React.createElement(GhostButton, {
            variant: "main",
            size: "large",
            onClick: this.chooseFile,
            className: className
        }, t('mediapopup.upload')), /*#__PURE__*/ React.createElement("input", {
            type: "file",
            ref: this.fileInput,
            onChange: this.handleFileChange,
            accept: MIME_CONFIG.forMediaManager.join(),
            style: {
                display: 'none'
            },
            multiple: !!this.props.allowMultipleUploads
        }));
    }
    constructor(...args){
        super(...args);
        _define_property(this, "fileInput", /*#__PURE__*/ React.createRef());
        _define_property(this, "chooseFile", ()=>{
            const { isVerificationNeeded, pushVerificationPopup } = this.props;
            if (isVerificationNeeded) {
                pushVerificationPopup('submit');
                return;
            }
            this.fileInput.current.value = '';
            this.fileInput.current.click();
        });
        _define_property(this, "handleFileChange", (e)=>{
            const files = Array.from(e.target.files);
            if (!files || files.length < 1) {
                return;
            }
            this.props.uploadFiles(files.map((file)=>({
                    file
                })));
        });
    }
}
export default enhance(UploadButton);
